const api = '/api/v1/auction.php';
import axios from 'axios';
export const auctionRepository =  {
    methods: {
        async register(data){
            return  axios.post(api,data);
        },
        async getAll(userId){
            return  axios.get(api,{
                params: {
                    M_USER_ID:userId
                }
            });
        },
    }
};

